module.exports = __webpack_public_path__ + "static/media/Madison Dominescy Headshot.64ed0881.jpeg";